export default function(blockTypesArray) {
	return `<v-alert :value="true" color="info" icon="info" outline class="ma-2">
        <b>Note:</b> Certain elements of this slide, including ${blockTypesArray.join(', ')} content, were generated using Bertha AI Assistant.
      </v-alert>`;
}
